import { Component, OnDestroy, OnInit, ElementRef, ViewChild, ViewChildren, QueryList, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../utils/froala.utils';
import { FormControl, FormGroup, Validators } from "@angular/forms";

import { Subscription ,  Subject, Observable, of, isObservable } from "rxjs";

import { genId } from '../../../core/services/genId';
import { NoteType } from '../../models/note-type.enum';
import { Note, objectIsArray, NotesData, NoteFilter } from '../../models/note.model';
import { RetentionPolicy } from "../../models/retention-policy.model";
import { NoteService } from '../../services/note.service';
import { SidePanelService } from '../../../common/services/side-panel.service';
import { StateType, DetailedFlowHistory, EntryType } from "../../models/flow.dto";
import { WorkOrderWithAssignments, WorkOrderStatus, WorkOrderType } from "../../models/work-order.model";
import { AuthService } from "../../../services/auth.service";
import { DocumentManagementService, IUploadFile, UploadedFile } from "../../services/document-management.service";
import { NoteRelatedItemType } from "../../models/note_relatedItemType.enum";
import { SidePanelBase } from "../../../common/components/side-panel-base.class";
import { OnBaseDocumentType, BlobDownloadRequest } from "../../../common/models/onBaseIntegrationAndMapping.model";

@Component({
    selector: "field-notes",
    templateUrl: "./field-notes.component.html",
    styleUrls: ['./notes.component.scss'],
    standalone: false
})

export class FieldNotesComponent extends SidePanelBase implements OnInit, OnDestroy, AfterViewInit {
    static componentName = 'FieldNotesComponent';

    public note$: Subscription = new Subscription();
    typeSubscription: Subscription;

    componentContext: any;
    currentDocType: OnBaseDocumentType;

    currentFilter: NoteFilter = {
        fromDate: null,
        toDate: null,
        userName: "",
        type: ""
    } as NoteFilter;

    documentTypes: OnBaseDocumentType[];
    editing: boolean = false;
    filesValid: boolean = true;
    flowOnBehalf: boolean = false;
    form: FormGroup;
    private _froalaOptions: any = null;
    get froalaOptions() : any {
        if (!this._froalaOptions) {
            this._froalaOptions = applyFroalaAriaFix({
                heightMax: 500,
                heightMin: 250,
                key: this.editorKey,
                saveInterval: 0,
                toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough'],
                typingTimer: 150,
                autofocus: true
            });
        }
        return this._froalaOptions;
    }

    replyForm: any;
    private _replyFroalaOptions: any = null;
    get replyFroalaOptions() : any {
        if (!this._replyFroalaOptions) {
            this._replyFroalaOptions = applyFroalaAriaFix({
                heightMax: 300,
                heightMin: 150,
                key: this.editorKey,
                saveInterval: 0,
                toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough'],
                typingTimer: 150,
                autofocus: true
            });
        }
        return this._replyFroalaOptions;
    }

    @ViewChildren('replyForm') replyForms: QueryList<ElementRef>;

    isSaving: boolean = false;
    notesData: any;
    noteType = NoteType;
    public noteText: string;

    questionContext: any = { notes: [] };

    reviewNotes: any;
    public replyText: string;
    selectedNoteType: NoteType = NoteType.General;
    stateType: StateType = StateType.ReviewForm;
    stateTypes = StateType;
    type: string = "";
    private _externalTypes = [NoteType.General];
    private _internalTypes = [NoteType.General, NoteType.Administrative, NoteType.Internal];
    _typeKeys: NoteType[] = [];
    get typeKeys(): NoteType[] {
        if (this._typeKeys.length === 0) {
            if (this.authService.User && this.authService.User.isInternal) {
                this._typeKeys = this._internalTypes;
                if (this.flowOnBehalf) {
                    this._typeKeys.push(NoteType.Clarification);
                }
            } else {
                this._typeKeys = this._externalTypes;
            }            
        }
        return this._typeKeys;
    }
    types = NoteType;
    workflowId: string;
    observer: Subject<boolean>;

    _users: string[];

    get notesUsers(): string[] {
        if (this._users == null || this._users.length === 0) {
            this._users = [];
            this._users.push("");
            if (this.questionContext != null && this.hasNotes) {
                let created = this.questionContext.notes.map(n => n.createdBy);
                created.forEach(c => {
                    if (this._users.includes(c) == false) {
                        this._users.push(c);
                    }                    
                });
            }
        }
        return this._users;        
    }

    get filteredNoteCount(): number {
        return this.filteredNotes.length;
    }

    get totalNotes(): number {
        if (this.questionContext == null || !this.hasNotes) return 0;
        return this.questionContext.notes.length;
    }

    get allNotes(): Note[] {
        if (this.questionContext == null || !this.hasNotes) return [];
        return this.questionContext.notes;
    }

    get filteredNotes(): Note[] {
        let filtered: Note[] = this.allNotes;
        if (this.currentFilter != null) {
            if (this.currentFilter.type != null && this.currentFilter.type != '') {
                filtered = filtered.filter(f => f.type.toString() == this.currentFilter.type);
            }
            if (this.currentFilter.userName != null && this.currentFilter.userName.length > 0) {
                filtered = filtered.filter(f => f.createdBy === this.currentFilter.userName);
            }
            if (this.currentFilter.fromDate != null) {
                filtered = filtered.filter(f => (new Date(f.createdDate)) >= this.currentFilter.fromDate);
            }

            if (this.currentFilter.toDate != null) {
                filtered = filtered.filter(f => (new Date(f.createdDate)) <= this.currentFilter.toDate);
            }
        }
        return filtered;
    }

    constructor(
        public _docSvc: DocumentManagementService,
        public notesService: NoteService,
        public sidePanelService: SidePanelService,
        public authService: AuthService,
        public detector: ChangeDetectorRef) {
        super();
     //   this.detector.detach();
    }

    ngOnInit(): void {        
        this.initializeForm();
        this.workflowId = this.notesService.workflowId;
        let noteObs$ = this.notesService.note$.subscribe((newNote: NotesData) => {
            this.reviewNotes = newNote.reviewNotes;
            this.stateType = newNote.stateType;
            this.observer = newNote.obs;
            this.initializeForm();
            this._users = [];
            this.questionContext = newNote.data;
            this.flowOnBehalf = (newNote.flowOnBehalf != null) ? newNote.flowOnBehalf : false;
            this.detector.detectChanges();
        });
        this.note$.add(noteObs$);
        this.typeSubscription = this._docSvc.getAllDocumentTypes().subscribe(
            (data: OnBaseDocumentType[]) => {
                console.log("types loaded");
                this.documentTypes = data;
                if (this.form) {
                    const typeCtrl = this.form.get("documentType");
                    if (typeCtrl) {
                        typeCtrl.setValue(this.documentTypes[0].name);
                    }
                }
                this.detector.detectChanges();
            },
            (error) => { console.error(error); }
        );
    }

    ngAfterViewInit(): void {
        if (this.replyForms != null) {
            this.replyForms.forEach(r => {
                r.nativeElement.opened = true;
            });
        }
    }


    ngOnDestroy(): void {
        if (this.note$) this.note$.unsubscribe;
        if (this.typeSubscription) this.typeSubscription.unsubscribe();
    }

    cancel(): void {
        this.sidePanelService.toggleSidePanel(false);

        if (this.observer)
            this.observer.complete();

        this.resetForm();
    }

    canCreateNoteType(type: any): boolean {
        if (this.authService.User && this.authService.User.isInternal) return true;
        return type === NoteType.General;
    }

    canViewNote(note: any): boolean {
        switch (note.type) {
            case NoteType.General: {
                return true;
            }
            case NoteType.Historical: {
                return this.authService.User && this.authService.User.isInternal;
            }
            case NoteType.Clarification:
            case NoteType.Internal: {
                return this.authService.User && this.authService.User.isInternal;
            }
            case NoteType.Administrative: {
                return note.createdById === this.authService.User.id;
            }
            default: {
                alert('Unknown note type');
                return true;
            }
        }
    }

    displayWorkItem(workItem: WorkOrderWithAssignments): boolean {
        return workItem.status !== WorkOrderStatus.Completed &&
            (workItem.type === WorkOrderType.Review || workItem.type === WorkOrderType.AdHocReview);
    }

    get hasNotes(): boolean {
        return this.isArray(this.questionContext.notes) && this.questionContext.notes.length > 0;
    }

    isArray(obj): boolean {
        return objectIsArray(obj);
    }

    displayExpander(obj) {        
        if (this.isArray(obj) && obj.length > 0)
            return true;

        return false;
    }

    fileUploaded(event: any): void {
        this.detector.detectChanges();
    }

    noteFilterChanged(filter: NoteFilter): void {
        this.currentFilter = filter;
    }

    onSubmit(): void {       
        this.validate();
        
        if (this.form.valid) {
            if (this.componentContext.files.files != null && this.componentContext.files.files.length > 0) {
                const type = this.form.controls["documentType"].value;
                for (let f = 0; f < this.componentContext.files.files.length; f++) {
                    (<UploadedFile>this.componentContext.files.files[f]).documentType = type;
                }
            }
            const note = this.buildNote();
            note.files = this.componentContext.files.files;
            note.notes = [];
            note.text = this.noteText;
            note.type = parseInt(this.form.controls['selectedNoteType'].value);
            this.resetForm();
            
            this.questionContext.notes.push(note);
            this.notesService.noteAdded$.next(note);            
        }
        this.detector.detectChanges();
    }

    openReplyForm(form: any): void {
        form.isReplying = true;
        form.replyText = '';
        form.opened = true;
        form.componentContext = {
            files: { value: [] }
        };

        form.componentData = {
            enabled: () => true,
            key: 'files',
            contextTarget: '$.files',
            validator: () => true,
            config: { useRadioButtons: false }
        };
        this.replyForm = form;
        this.detector.detectChanges();
    }

    reply(parentNote: Note, form: any): void {
        if (this.validateReply()) {
            const reply = this.buildNote();
            reply.files = form.componentContext.files.value;
            reply.text = this.replyText;
            reply.type = parentNote.type;
            parentNote.notes.push(reply);

            const index = this.questionContext.notes.findIndex(x => x.id === parentNote.id);
            form.opened = true;
            this.questionContext.notes[index] = parentNote;
            this.notesService.noteAdded$.next(parentNote);
            this.resetReplyForm(form);          
        } else {
            this.detector.detectChanges();
        }
        
    }

    resetReplyForm(form: any): void {
        form.replyText = '';
        form.opened = true;
        form.isReplying = false;
        form.isDirty = false
        this.replyText = "";
        this.detector.detectChanges();
    }

    setNoteType(data: any): void {
        this.selectedNoteType = this.form.get("selectedNoteType").value;
        this.detector.detectChanges();
    }

    toggleReply(replyForm: any) {
        replyForm.opened = !replyForm.opened;
        this.detector.detectChanges();
    }

    validate(): void {
        this.detector.detectChanges();
        this.form.controls["selectedNoteType"].updateValueAndValidity();
        this.form.controls["noteText"].updateValueAndValidity();
        this.form.controls["files"].updateValueAndValidity();
        this.form.controls["documentType"].updateValueAndValidity();
        this.filesValid = true;
        if (this.form.controls["files"] != null && this.form.controls["files"].value != null && this.form.controls["files"].value.length > 0) {
            this.filesValid = this.form.controls["documentType"] != null && this.form.controls["documentType"].value != null && this.form.controls["documentType"].value.length > 0;
        }
        let filesValidCtrl = this.form.get('filesValid');
        if (filesValidCtrl != null) filesValidCtrl.setValue(this.filesValid);
        if (this.form.valid && this.filesValid) {
            this.noteText = stripFroalaWatermark(this.form.controls["noteText"].value);
        } else {
            this.form.controls["noteText"].markAsDirty();
            this.form.controls["selectedNoteType"].markAsDirty();
            this.form.controls["files"].markAsDirty();
            this.form.controls["documentType"].markAsDirty();
        }
    }

    validateReply(): boolean {
        this.replyForm.isDirty = true;
        this.detector.detectChanges();
        if (this.replyForm && this.replyForm.replyText && this.replyForm.replyText.length > 0) {
            this.replyText = stripFroalaWatermark(this.replyForm.replyText);
            return true;
        }
        return false;
    }

    public buildNote(): Note {
        const id = genId();
        return {
            createdBy: this.authService.User.displayName,
            createdById: this.authService.User.id,
            createdDate: new Date(), 
            documentType: "Note",
            relatedItemId: this.workflowId,
            relatedItemType: NoteRelatedItemType.Workflow,
            id: id,
            isDeleted: false,
            noteId: id,
            noteUrgency: 0,
            priority: 3,
            referenceUri: '',
            retentionPolicy: {} as RetentionPolicy,
            type: NoteType.General,
            notes: [],
            files: [],
        } as Note;
    }

    public initializeForm(): void {
        this.notesData = {
            enabled: () => true,
            key: 'files',
            contextTarget: '$.files',
            validator: () => true,
            config: { useRadioButtons: false }
        };

        this.componentContext = {
            files: { files: [] }
        };

        let components = {
            selectedNoteType: new FormControl(NoteType.General, [Validators.required]),
            noteText: new FormControl('', [Validators.required]),
            files: new FormControl([]),
            filesValid: new FormControl(true, [Validators.requiredTrue]),
            documentType: new FormControl("", [])
        };

        this.form = new FormGroup(components);
        this.form.patchValue({ selectedNoteType: NoteType.General });
    }

    public resetForm(): void {
        this.componentContext = {
            files: { value: [] }
        };
        const docType = this.documentTypes != null && this.documentTypes.length > 0 ? this.documentTypes[0].name : "";
        this.form.reset({ selectedNoteType: NoteType.General, noteText: '', files: [], documentType: docType, filesValid: true });
        this.form.markAsPristine();
        this.form.markAsUntouched();
    }

    @ViewChild('downloadLink') public downloadLink: ElementRef;
    downloadFile(file: IUploadFile): any {
        this._docSvc.downloadBlob({ uri: file.blobUri, contentType: file.type, fileName: file.fileName } as BlobDownloadRequest).subscribe(
            (data) => {
                this.renderBlob(data, file.type, file.fileName);
            }),
            (error) => { console.error(error); };    
    }

    private renderBlob(data: any, contentType: string, fileName: string): void {
        const blob = new Blob([data], { type: contentType });
        let url = window.URL.createObjectURL(blob);
        const link = this.downloadLink.nativeElement;
        link.href = url;
        link.download = fileName;
        link.click();
    }
}
